import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { merge, Observable, of as observableOf } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatSort, Sort, MatSortHeader } from "@angular/material/sort";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { SellerAssignUtilityDialog } from "../incs/seller-assign-utility.component";
import { Pair } from "../../obj/Pair";
import { EntityBase } from "../../entity/EntityBase";
import { State } from "../../entity/State";
import { Utility } from "../../entity/Utility";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { KilowantFee } from "../../entity/KilowantFee";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { HeaderComponent } from "../incs/header.component";
import { CurrencyPipe, DatePipe } from "@angular/common";

@Component({
    selector: "kilowant-seller-fees",
    templateUrl: "../../../html/seller/main-seller-fees.html",
    animations: [
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
        ]),
    ],
    imports: [HeaderComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatSortHeader, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, CurrencyPipe, DatePipe]
})
export class SellerFeesComponent extends AbstractSellerComponent {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    dialogRef: MatDialogRef<any> = null!;

    displayedColumns: string[] = ["#","Utilities", "LoadZones", "RateClasses", "StartDate", "ValidUntil", "Fee"];
    dataSource: MatTableDataSource<KilowantFee>;
    user: User = new User();

    utilities: Utility[] = null!;

    expandedElement: any | null;


    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        this.reloadUser().then(u=>{
           this.generalService.getKilowantFeesList().then(fees=>{
              this.dataSource = new MatTableDataSource(fees);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              this.dataSource.sortingDataAccessor = (item, property) => {
              switch (property) {
                   case "Fee": {
                       return item.fee;
                   }
                   default: {
                        return "";
                   }
                 }
              };
           });
        });
    }
}